import { z } from "zod";

export const AddAttendanceSchema = z
  .object({
    employee_code: z.string().min(1, "Employee code is required"),

    checkin_time: z
      .string()
      .regex(
        /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/,
        "Invalid time format (must be HH:mm:ss, 24-hour)",
      )
      .optional()
      .or(z.literal("")),

    attendance_status: z
      .string()
      .min(1, "Attendance status is required")
      .refine((val) => ["FULLDAY", "ABSENT", "HALFDAY"].includes(val), {
        message: "Status must be FULLDAY, ABSENT, or HALFDAY",
      }),

    date: z
      .string()
      .min(1, "Date is required")
      .regex(/^\d{4}-\d{2}-\d{2}$/, "Date must be in YYYY-MM-DD format"),
  })

  // Conditional validation
  .superRefine((data, ctx) => {
    if (data.attendance_status === "FULLDAY") {
      if (!data.checkin_time) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ["checkin_time"],
          message: "Check-in time is required for Full Day",
        });
      }
    }

    if (data.attendance_status === "HALFDAY") {
      if (!data.checkin_time) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ["checkin_time"],
          message: "Check-in time is required for Half Day",
        });
      }
    }
  });

export type AttendanceForm = z.infer<typeof AddAttendanceSchema>;